import React from 'react';


var pic1 = require('../../assets/images/testimonials/pic1.jpg');
var pic2 = require('../../assets/images/testimonials/pic2.jpg');
var pic3 = require('../../assets/images/testimonials/pic3.jpg');
var pic4 = require('../../assets/images/testimonials/pic4.jpg');


const  TestimonialsGridBlock = (props) => {
  return(	
  <>	  	
	{/* <!-- SECTION CONTENT START --> */} 
	<div className="section-full bg-repeat p-t100 p-b70">
		<div className="container">
		
			{/* <!-- TITLE START --> */}   
			<div className="section-head text-center">
				<h2><span className="site-text-primary">Our </span> Staff</h2>
				<div className="wt-separator-outer ">
					<div className="wt-separator style-icon">
						<i className="fa fa-leaf text-black"></i>
						<span className="separator-left site-bg-primary"></span>
						<span className="separator-right site-bg-primary"></span>
					</div>                            
				</div>
				<p>{process.env.REACT_APP_SITE_TITLE} offers a comprehensive educational experience with a diverse team of qualified educators. Here are some staff roles:</p>
			</div>
			{/* <!-- TITLE START --> */}
			
			{/* <!-- TESTIMONIAL GRID STYLE 2 --> */}    
			<div className="section-content">
				<div className="row testimonial-grid">
				
					{/* <!-- COLUMNS 1 --> */}    
					<div className="col-lg-6 col-md-6 m-b30">
						<div className="testimonial-grid-2">
							<div className="testimonial-text">
							  <span className="fa fa-quote-left"></span>
							  <p>Lorem Ipsum is simply dummy text of the printing and industry. Lorem Ipsum has been the industry's standard.</p>
							</div>
							<div className="testimonial-detail clearfix">
								<div className="testimonial-pic radius shadow"><img src={pic1} width="100" height="100" alt="" /></div>
								<strong className="testimonial-name">Alan Monre</strong>
								<span className="testimonial-position">Cfo, Walmart</span>
							</div>
						</div>
					</div>
					{/* <!-- COLUMNS 2 --> */}
					<div className="col-lg-6 col-md-6 m-b30">
						<div className="testimonial-grid-2">
							<div className="testimonial-text">
							  <span className="fa fa-quote-left"></span>
							  <p>Lorem Ipsum is simply dummy text of the printing and industry. Lorem Ipsum has been the industry's standard.</p>
							</div>
							<div className="testimonial-detail clearfix">
								<div className="testimonial-pic radius shadow"><img src={pic2} alt="" width="100" height="100" /></div>
								<strong className="testimonial-name">Resa Smith</strong>
								<span className="testimonial-position">Cfo Loop Inc</span>
							</div>
						</div>
					</div>
					{/* <!-- COLUMNS 3 --> */}
					<div className="col-lg-6 col-md-6 m-b30">
						<div className="testimonial-grid-2">
							<div className="testimonial-text">
							  <span className="fa fa-quote-left"></span>
							  <p>Lorem Ipsum is simply dummy text of the printing and industry. Lorem Ipsum has been the industry's standard.</p>
							</div>
							<div className="testimonial-detail clearfix">
								<div className="testimonial-pic radius shadow"><img src={pic3} alt="" width="100" height="100" /></div>
								<strong className="testimonial-name">Lulla Smith</strong>
								<span className="testimonial-position">Creative Designer.</span>
							</div>
						</div>
					</div>
					{/* <!-- COLUMNS 4 --> */}
					<div className="col-lg-6 col-md-6 m-b30">
						<div className="testimonial-grid-2">
							<div className="testimonial-text">
							  <span className="fa fa-quote-left"></span>
							  <p>Lorem Ipsum is simply dummy text of the printing and industry. Lorem Ipsum has been the industry's standard.</p>
							</div>
							<div className="testimonial-detail clearfix">
								<div className="testimonial-pic radius shadow"><img src={pic4} alt="" width="100" height="100" /></div>
								<strong className="testimonial-name">Ariol Perry</strong>
								<span className="testimonial-position">Creative Designer.</span>
							</div>
						</div>
					</div>
					{/* <!-- COLUMNS 5 --> */}
					<div className="col-lg-6 col-md-6 m-b30">
						<div className="testimonial-grid-2">
							<div className="testimonial-text">
							  <span className="fa fa-quote-left"></span>
							  <p>Lorem Ipsum is simply dummy text of the printing and industry. Lorem Ipsum has been the industry's standard.</p>
							</div>
							<div className="testimonial-detail clearfix">
								<div className="testimonial-pic radius shadow"><img src={pic1} alt="" width="100" height="100" /></div>
								<strong className="testimonial-name">Resa Smith</strong>
								<span className="testimonial-position">Creative Designer.</span>
							</div>
						</div>
					</div>
					{/* <!-- COLUMNS 6 --> */}
					<div className="col-lg-6 col-md-6 m-b30">
						<div className="testimonial-grid-2">
							<div className="testimonial-text">
							  <span className="fa fa-quote-left"></span>
							  <p>Lorem Ipsum is simply dummy text of the printing and industry. Lorem Ipsum has been the industry's standard.</p>
							</div>
							<div className="testimonial-detail clearfix">
								<div className="testimonial-pic radius shadow"><img src={pic2} alt="" width="100" height="100" /></div>
								<strong className="testimonial-name">Alan Monre</strong>
								<span className="testimonial-position">Ceo Apple</span>
							</div>
						</div>
					</div>
												
				</div>
			</div>
			
		</div>
	</div>
	{/* <!-- SECTION CONTENT END --> */}
	
	
  </>
  )
}
 export default TestimonialsGridBlock;